import autobind from 'core-decorators/lib/autobind';


class DeferredTask {
  constructor(task) {
    this.task = task;
    this.promise = new Promise(this.attachPromiseMethods);
  }

  @autobind
  attachPromiseMethods(resolve, reject) {
    this.resolve = resolve;
    this.reject = reject;
  }

  run() {
    this.task().then(this.resolve, this.reject);
  }
}


export default class TaskSequence {
  tasksStack = [];
  isInProgress = false;

  @autobind
  runFirstTask() {
    if (this.tasksStack.length) {
      this.isInProgress = true;
      this.tasksStack.shift().run();
    } else {
      this.isInProgress = false;
    }
  }

  @autobind
  runSequentially(task) {
    const deferredTask = new DeferredTask(task);
    this.tasksStack.push(deferredTask);

    if (!this.isInProgress) {
      this.runFirstTask();
    }

    return deferredTask.promise.then(this.runFirstTask, this.runFirstTask);
  }
}



// WEBPACK FOOTER //
// ./src/transport/utils/task-sequence.js